import { useRef } from "react";
import classes from "./Body.module.css";
import Nav from "../Nav/Nav";
import sunimg from "../../Images/sun1.png";

const Body = ({ setCity, city, stat }) => {
  const search = useRef();
  const searchIt = () => {
    setCity(search.current.value);
  };
  return (
    <div className={classes.container}>
      <div className="d-flex">
        <div className={classes.left}>
          <div className="align-self-end">
          <div className="text-end">
            <span className={classes.bigCity}>
              {stat.cityName}
            </span> <br/>
            <span className={classes.bigCountry}>{stat.country}</span>
          </div>
          </div>
          <div>
            <div className="text-center mb-3">
              <img className={classes.day_img} src={`dayImg${stat.is_day}.png`} alt="day or night img"/>
            </div>
            <div>
              <h2 className={classes.bigTemp}>
                {stat.temp}
                <span>
                  <sup>o</sup>c
                </span>
              </h2>
            </div>
            <div>
              <p className={classes.day_text}>{stat.text}</p>
            </div>
          </div>
          <div className="w-100">
            <Nav />
          </div>
        </div>
        <div className={classes.right}>
          <div className="text-center mb-4 mt-3">
            <img className={classes.sun} src={sunimg} alt="sun" />
          </div>
          <div>
            <h1 className={classes.h1_heading}>Haze</h1>
          </div>
          <div className="d-flex mb-3">
            <div className={classes.inp}>
              <input ref={search} placeholder="Search any city" />
              <button onClick={searchIt}>Search</button>
            </div>
          </div>
          <div className="text-center">
            <span className={classes.city}>
              {stat.cityName},{stat.country}
            </span>
          </div>
          <div>
            <ul className={classes.data_list}>
              <li>
                <span>Temperature</span>
                <span>
                  {stat.temp}
                  <sup>
                    <small>
                      <b>o</b>
                    </small>
                  </sup>
                  C (Haze)
                </span>
              </li>
              <li>
                <span>Humidity</span>
                <span>{stat.humdi}%</span>
              </li>
              <li>
                <span>Visibility</span>
                <span>{stat.visib}Km</span>
              </li>
              <li>
                <span>Wind Speed</span>
                <span>{stat.winds}Km/h</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Body;
